import DiscoveryEmptyState from './DiscoveryEmptyState';
import MobileDiscoveryCompanyCard from './MobileDiscoveryCompanyCard';
import MobileLoadMoreFooter from './MobileLoadMoreFooter';
import icJobSearch from '../../assets/img/ic-job-search.svg';

const MobileCompanyResults = ({ mobilePagination, favorites, onFavoriteToggle, onOpenCompany, onClearFilters, onOpenFilters, hideCity = false }) => (
    mobilePagination.totalCount === 0 ? (
        <DiscoveryEmptyState
            className="discovery-empty-state--mobile-jobs"
            icon={icJobSearch}
            title="No matching companies found"
            description="Try removing one or more filters or adjust your search."
            primaryAction={{
                label: 'Clear search & filters',
                variant: 'primary',
                onClick: onClearFilters,
            }}
            secondaryAction={{
                label: 'Adjust filters',
                variant: 'outline-secondary',
                onClick: onOpenFilters,
            }}
        />
    ) : (
        <div className="mobile-company-list">
            {mobilePagination.mobileItems.map((company) => (
                <MobileDiscoveryCompanyCard
                    key={company._id}
                    company={company}
                    hideCity={hideCity}
                    isFavorite={favorites.has(String(company._id))}
                    onFavoriteToggle={onFavoriteToggle}
                    onOpenCompany={onOpenCompany}
                />
            ))}
            <MobileLoadMoreFooter
                visibleCount={mobilePagination.visibleCount}
                totalCount={mobilePagination.totalCount}
                itemLabel="companies"
                onLoadMore={mobilePagination.loadMore}
                isLoading={mobilePagination.isLoadingMore}
                hasMore={mobilePagination.hasMore}
            />
        </div>

    )
);

export default MobileCompanyResults;
